export default "__VITE_ASSET__B5QM8ltY__"